import { ManualBankTransferInfo, IManualTransfer } from '@interfaces'
import { api } from '@utils/api/api'

export async function manualTransfer(
  data: IManualTransfer,
): Promise<ManualBankTransferInfo> {
  return await api.post('/api/v1/manual-transfer/deposit', data)
}
